export enum ReactSelectStyleKeysEnum {
  // every possible style key
  // source: https://react-select.com/styles#style-object
  clearIndicator = 'clearIndicator',
  container = 'container',
  control = 'control',
  dropdownIndicator = 'dropdownIndicator',
  group = 'group',
  groupHeading = 'groupHeading',
  indicatorsContainer = 'indicatorsContainer',
  indicatorSeparator = 'indicatorSeparator',
  input = 'input',
  loadingIndicator = 'loadingIndicator',
  loadingMessage = 'loadingMessage',
  menu = 'menu',
  menuList = 'menuList',
  menuPortal = 'menuPortal',
  multiValue = 'multiValue',
  multiValueLabel = 'multiValueLabel',
  multiValueRemove = 'multiValueRemove',
  noOptionsMessage = 'noOptionsMessage',
  option = 'option',
  placeholder = 'placeholder',
  singleValue = 'singleValue',
  valueContainer = 'valueContainer',
}

export const defaultBaseSelectStyles = {
  // default styles
  control: {
    minHeight: '32px',
    height: '32px',
  },
  option: {
    minHeight: '32px',
    height: '32px',
    padding: '4px 12px',
  },
  dropdownIndicator: {
    padding: '5px',
  },
};
